import {H1} from 'components/Typography';
import {FC} from 'react';

type WizardSectionHeaderProps = {
    subTitle: string;
    title: string;
};
const WizardSectionHeader: FC<WizardSectionHeaderProps> = ({
    subTitle,
    title,
}) => (
    <div className="relative p-12 pt-6">
        <H1 className="mt-0 text-4xl text-white md:text-5xl">{title}</H1>
        <p className=" mt-4 text-xl text-white md:text-2xl">{subTitle}</p>
    </div>
);
export default WizardSectionHeader;
